import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GoldButton } from "./ui-kit";

export function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("kmr-cookie-consent")) setShow(true);
  }, []);
  const choose = (v) => {
    localStorage.setItem("kmr-cookie-consent", v);
    setShow(false);
  };
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 inset-x-0 z-[60] p-4"
          data-testid="cookie-banner"
        >
          <div className="glass max-w-3xl mx-auto rounded-2xl p-6 flex flex-col sm:flex-row items-center gap-4">
            <p className="text-sm text-muted-foreground flex-1">
              Ce site utilise uniquement des cookies essentiels à son fonctionnement. Aucun traceur publicitaire n'est chargé sans votre consentement.
            </p>
            <div className="flex gap-3">
              <GoldButton variant="outline" onClick={() => choose("essential")} data-testid="cookie-refuse">Essentiels uniquement</GoldButton>
              <GoldButton onClick={() => choose("all")} data-testid="cookie-accept">J'ai compris</GoldButton>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
